export interface ICheckout {
  batchId: number;
}

export interface ITinggEncryptResponse {
  param: string;
  accessKey: string;
  countryCode: string;
}
